interface ILoading {
  width?: string;
  height?: string;
}

const Loading = ({ width = "100%", height = "100%" }: ILoading) => {
  return (
    <div style={{ width: width, height: height }} className="loading">
      <div></div>
    </div>
  );
};

export default Loading;
